import {Grid} from "@mui/material";
import Lista_Proyectos_Dashboard from "./Lista_Proyectos_Dashboard";
import Boton_Crear_Proyecto from "./SubComponentes/Boton_Crear_Proyecto";

const Crear_Proyecto = () => {
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>
            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Boton_Crear_Proyecto/>
            </Grid>
            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Lista_Proyectos_Dashboard/>
            </Grid>
        </Grid>
    )
}
export default Crear_Proyecto;

